import { RoutalLoader } from '@nx-smartmonkey/ui';
import queryString from 'query-string';
import { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

import { EventTrackTypes } from '../../constants/EventTracks';
import * as routes from '../../constants/Routing';
import { useCaptureEvents } from '../../hooks/useCaptureEvents';
import { useSessionMagicLink } from './hooks/useSessionMagicLink';

export const MagicLink = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { capture } = useCaptureEvents();
  const searchParams = queryString.parse(search ? search : ``);
  const { vehicle_id, route_id, from_planner_onboarding } = searchParams;

  const {
    success: magicLinkValidated,
    error: magicLinkError,
    run: retrieveMagicLink,
    data: routeId,
  } = useSessionMagicLink({
    vehicleId: vehicle_id as string,
    routeId: route_id as string,
  });

  useEffect(() => {
    if (vehicle_id && route_id) {
      retrieveMagicLink();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (magicLinkValidated) {
      capture({
        type: EventTrackTypes.UserLoggedIn,
        payload: {
          [`From`]: `Magic link`,
        },
      });
      navigate(
        routes.PRIVATE_ROUTES.ROUTE_DETAILS.replace(`:routeId`, routeId as string).concat(
          from_planner_onboarding ? `?from_planner_onboarding=true` : ``
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [magicLinkValidated]);

  useEffect(() => {
    if (magicLinkError) {
      navigate(routes.ROOT);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [magicLinkError]);

  if (!vehicle_id || !route_id) {
    return <Navigate to={routes.ROOT} />;
  }

  return (
    <div style={{ width: `100%`, height: `100%` }}>
      <RoutalLoader />
    </div>
  );
};
